import { Component } from '@angular/core';
import { MatDrawerContainer, MatDrawer } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'sibat-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [MatDrawerContainer, MatDrawer, RouterOutlet],
})
export class SideNavComponent {}
